import { useLocation } from "react-router-dom";
import { BubblyLink } from "../library/src";

// Bubbly sweep colours: brand blue settling into the page background.
const START = "#3FA9E0";
const END = "#0A0E1A";
const DURATION = 1100;

const LINKS = [
  { to: "/", text: "Home" },
  { to: "/about", text: "About" },
  { to: "/projects", text: "Projects" },
];

export default function Header() {
  // Subscribing to the location forces this persistent header to re-render on
  // navigation, so the active underline (and BubblyLink's own state) updates.
  const { pathname } = useLocation();

  return (
    <header className="site-header">
      <span className="wordmark">
        <BubblyLink to="/" colorStart={START} colorEnd={END} duration={DURATION}>
          <span className="wordmark-inner">
            <span className="wordmark-dot" />
            iolivera<span className="wordmark-ext">.dev</span>
          </span>
        </BubblyLink>
      </span>

      <nav className="nav">
        {LINKS.map((l) => (
          <span
            key={l.to}
            className={`nav-item ${pathname === l.to ? "active" : ""}`}
          >
            <BubblyLink
              to={l.to}
              colorStart={START}
              colorEnd={END}
              duration={DURATION}
            >
              {l.text}
            </BubblyLink>
          </span>
        ))}
      </nav>
    </header>
  );
}
